export const trackGa = (event, link, windowId, buttonStyle) => {
	const DDC = window.DDC || {};

	if (DDC.fireTrackingEvent) {
		DDC.fireTrackingEvent({
			action: 'clicked',
			element: event.target,
			event: 'widgetUserEvent',
			id: `links-share-${link}`,
			widgetName: 'ws-links-share',
			widgetState: `default (${
				buttonStyle === 'link' ? 'link list' : 'button list'
			})`,
			windowId
		});
	}
};
